<template>
  <div class="companydic" @click="goDetailPage(dic.pk)">
    <div class="logo">
      <img :src="dic.logo" alt="加载图片失败" />
    </div>
    <div class="rightView">
      <span class="title">{{dic.name}}</span>
      <p class="content">{{dic.content}}</p>
      <p class="desc">
        <span class="position tab">
          <img class="icon" :src="images.ceo" />
          <span class="text">{{dic.owner.name}}</span>
        </span>
        <span class="product tab">
          <img class="icon" :src="images.product" />
          <span class="text">{{dic.product_count}}个产品</span>
        </span>
        <span class="income tab">
          <img class="icon" :src="images.income" />
          <span class="text">{{dic.exist_income}}蓝钻</span>
        </span>
        <span class="member tab">
          <img class="icon" :src="images.member" />
          <span class="text">{{dic.member_count}}人</span>
        </span>
      </p>
    </div>
  </div>
</template>


<script>
import { Utils } from "@/utils";

import {
  IMG_COMPANY_CEO_ICON,
  IMG_COMPANY_PRODUCT_ICON,
  IMG_COMPANY_INCOME_ICON,
  IMG_COMPANY_MEMBER_ICON
} from "../assets";

import { types as CompanyTypes } from "@/store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CompanyGradeItem",
  props: {
    dic: {
      type: Object
    }
  },
  data() {
    return {
      images: {
        ceo: IMG_COMPANY_CEO_ICON,
        product: IMG_COMPANY_PRODUCT_ICON,
        income: IMG_COMPANY_INCOME_ICON,
        member: IMG_COMPANY_MEMBER_ICON
      }
    };
  },
  methods: {
    // 进入详情页
    goDetailPage(pk) {
      this.$router.push(`/company/${pk}`);
    }
  }
};
</script>

<style lang="less" scoped>
.companydic {
  display: flex;
  margin: 0 15px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
  .logo {
    width: 100px;
    height: 100px;
    margin-right: 15px;
    border-radius: 8px;
    background-color: #f4f3f3;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    img {
      width: 100%;
      max-height: 100%;
    }
  }
  .rightView {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      color: #333333;
      font-size: 15px;
      margin-bottom: 5px;
      height: 20px;
      line-height: 20px;
      overflow: hidden;
    }
    .content {
      color: #666666;
      font-size: 13px;
      line-height: 23px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 5px;
      // height: 50px;
    }
    .desc {
      display: flex;
      flex-direction: row;
      color: #999999;
      font-size: 13px;
      overflow: hidden;
      height: 20px;
      line-height: 20px;
      .tab {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;
        &.position {
          max-width: 150px;
        }
        .icon {
          height: 15px;
          margin-right: 5px;
        }
        .text {
          color: #999999;
          font-size: 12px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>